import PayJP from "@/libs/payjp";

export const DIContainer:{[key: string]: any} = {
  payjp: {} as PayJP,
};
